import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { useLoader } from "./LoaderContext";


function RouteChangeHandler() {
    const {pathname} = useLocation();
    const {setLoading} = useLoader();
    const navType = useNavigationType();

    useEffect(() => {
        if(navType === 'PUSH'){
        setLoading(true);

        const timer = setTimeout(() => {
            setLoading(false);
            window.scrollTo({ top: 0, behavior: 'smooth'});
        }, 600);

        return()=> clearTimeout(timer);
    } else {
        window.scrollTo({ top: 0, behavior: 'smooth'});
    }
    }, [pathname, navType, setLoading])

  return null;
}

export default RouteChangeHandler